import React from 'react';
import PropTypes from 'prop-types';
import IcoMoon from 'react-icomoon';
import iconSet from '../../assets/icons/icomoon/selection.json';

const MoleculeIconTitle = ({
  text = null,
  className = null,
  icon = null,
  size = '',
  svg = null,
  style  
}) => {
  const iconClassMap = {
    'chat': 'icon-chat',
    'globe': 'icon-globe',
    'phone': 'icon-phone',
    'question': 'icon-question',
    'bubble2': 'icon-chat',
    'sphere': 'icon-globe',
    'Vector10': 'icon-phone',
    'question-mark': 'icon-question',
    'alert-error' : 'icon-alert-error',
    'alert-info' : 'icon-alert-info',
    'danger': 'icon-danger',
  };

  const titleClassName = `text-h1 ${className || ''}`.trim();
  const iconClass = iconClassMap[icon] || '';

  return (
    <div className="molecule_icon-title">
      {svg ? (
        <span className="icon"><IcoMoon iconSet={iconSet} icon={svg} /></span>
      ) : (
        <span className={`icon ${size} ${iconClass}`}></span>
      )}
      <p className={titleClassName} style={style}>{text}</p>
    </div>
  );
};

MoleculeIconTitle.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
  svg: PropTypes.string,
  style: PropTypes.object,
};

MoleculeIconTitle.defaultProps = {
  text: null,
  className: null,
  icon: null,
  size: '',
  svg: null
};

export default MoleculeIconTitle;
